import { Outlet } from "react-router-dom";
import AuthProvider from "../AuthProvider";

export default function ProtectedRoutes() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  )
}